<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { siteUrl } from '@/configs/urls'

const visible = ref(false)
const isShowSubmenus = ref(false)

const telegramLinks = ['https://t.me/+989101369884', 'https://t.me/+989356049661']
const whatsappLinks = ['https://wa.me/989101369884', 'https://wa.me/989356049661']

const randomTelegramLink = ref('')
const randomWhatsappLink = ref('')

onMounted(() => {
  randomTelegramLink.value = telegramLinks[Math.floor(Math.random() * telegramLinks.length)]
  randomWhatsappLink.value = whatsappLinks[Math.floor(Math.random() * whatsappLinks.length)]
})
</script>

<template>
  <div class="card flex justify-center">
    <Drawer v-model:visible="visible" class="bg-[#2626BF]! text-white rounded-b-3xl" :show-close-icon="false"
      position="top" style="height: auto">
      <div class="flex items-center justify-between pb-6 mb-6 border-b pt-8">
        <a href="/" class="mr-2 block lg:hidden">
          <img src="/img/header/Logo-mobile.svg" />
        </a>
        <div class="cursor-pointer" @click="visible = false">
          <img src="/img/header/icon-close.svg" />
        </div>
      </div>

      <div class="flex flex-col">
        <a :href="siteUrl('/')" class="px-3 py-2 text-white">خانه</a>
        <a :href="siteUrl('/blog/')" class="px-3 py-2 text-white">وبلاگ</a>

        <div class="w-full flex flex-col gap-3 py-2 px-3">
          <div class="cursor-pointer flex items-center gap-2.5 text-white font-normal text-sm"
            @click="isShowSubmenus = !isShowSubmenus">
            <span>پشتیبانی</span>
            <img src="/img/header/arrow-square-down.svg" :class="isShowSubmenus ? 'rotate-180' : ''" />
          </div>
          <div v-if="isShowSubmenus"
            class="text-[#2626BF] bg-white rounded-xl shadow-lg px-4 p-3 mb-2 text-sm z-50 w-full">
            <a id="btn-telegram" :href="randomTelegramLink" class="flex items-center gap-1 mb-4">
              <img src="/img/footer/telegram-2.svg" alt="telegram-icon" />
              تلگرام
            </a>
            <a id="btn-whatsapp" :href="randomWhatsappLink" class="flex items-center gap-1">
              <img src="/img/footer/whatsapp2.svg" alt="whatsapp-icon" />
              واتساپ
            </a>
          </div>
        </div>

        <a :href="siteUrl('/terms')" class="px-3 py-2 text-white">قوانین پی‌جیب</a>
      </div>
    </Drawer>
    <img src="/img/header/menu-burger-circle-gray.svg" class="block lg:hidden" @click="visible = true" />
  </div>
</template>
